export const stringsKey = "FileUpload";
export const englishStrings = {
	maxAllowedDurationError: "Maximum allowed audio duration time is",
	minutesText: "minutes",
	fileTypeExtensionError: "Only mp3 & wav files allowed",
	playAudioFileError: "Error loading audio file url, Please try again",
	newChip: "new",
	duration: "Duration",
	playAudioTooltip: "Play Audio",
	removeAudioTooltip: "Remove Audio",
	uploadAudioTooltip: "Upload mp3/wav file",
	noFileSelectedMessage: "Upload .mp3/.wav file, maximum duration",
	fileUploadValidationMessage: "The file upload field is required",
	removeAudioFileError: "Error deleting audio file, Please try again",
	confirmRemoveAudioMessage: "Are you sure you want to remove audio file?",
	positiveActionText: "Yes",
	negativeActionText: "No",
	clickText: "Click",
	hereText: "here",
	voiceRecordingManualText:
		"to learn how to create a voice recording in the right format",
};
